import { readSiteUrl } from 'shared/lib/env';

/** Canonical production URL (www). Override via VITE_SITE_URL at build time. */
export const SITE_URL = readSiteUrl().replace(/\/$/, '') || 'https://www.takshify.ai';

/** Origin for auth redirects - uses browser origin in client, SITE_URL for SSR/docs. */
export function getAppOrigin(): string {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return SITE_URL;
}
